import {
    Box, Stack, FormControl, Select,
    MenuItem, InputLabel, Paper,
    Typography,
    Popover,
    Button,
    Autocomplete,
    TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { DatePicker, DateRangePicker } from "rsuite";
import ViewTransactionsRanges from "../../../HelperFunctions/ViewTransactionsRanges";
import { DateFormater, GetReadOnlyInputProps } from "../../../HelperFunctions/HelperFunctions";
import { ArrowUpward, CalendarMonth } from "@mui/icons-material";
import { ChargeBackChart, PercentageBar, } from "./ChargeBackChart";
import { useLoaderData } from "react-router-dom";
import { chargeBacksPie, pendingBarGraph } from "../../../API/backendAPI";
import { enqueueSnackbar } from "notistack";


const ChargeBacksDetails = ({ selectedProfitCenter, selectedMerchantProvider, dateRange, setDateRange, date, setDate }) => {

    const { headerCorporation, Previlage } = useLoaderData();

    const labelOrder = ["Pending", "Irreversible", "Reversed"];
    const viewTransaction = ViewTransactionsRanges();
    const defaultOption =
        viewTransaction.find(opt => opt.date === "Past 90 Days") ||
        viewTransaction.find(opt => opt.date === "Range");
    const [transaction, setTransaction] = useState(defaultOption ? defaultOption.date : "");
    const [anchorEl, setAnchorEl] = useState(null);
    const [PCdate, setPCDate] = useState(new Date());
    const [chargeBacksLabelsData, setChargeBacksLabelsData] = useState({
        labels: labelOrder,
        series: [0, 0, 0],
        percentage: [0, 0, 0],
        winRate: 0
    });
    const [pendingChargeBarData, setPendingChargeBarData] = useState({});
    const [tempDateRange, setTempDateRange] = useState(dateRange);
    const [tempPendingChargeBackDate, setTempPendingChargeBackDate] = useState(new Date());

    useEffect(() => {

        getChargeBacksPieData();

    }, [selectedProfitCenter, dateRange]);

    useEffect(() => {

        getPendingChargeBacksBarData();

    }, [
        selectedProfitCenter,
        // PCdate
        date
    ]
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const formatUSAmount = (value) => {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return "0";
        return numericValue.toLocaleString("en-US");
    };



    const getChargeBacksPieData = async () => {

        try {



            if (!headerCorporation) return;

            const payload = {
                corporation_id: headerCorporation,
                pc_id: selectedProfitCenter.ID === "select" ? "" : selectedProfitCenter.ID,
                from_date: DateFormater(dateRange[0]),
                to_date: DateFormater(dateRange[1]),
            };
            const getChargeBacks = await chargeBacksPie(payload);
            const apiData = getChargeBacks?.data ?? [];

            const seriesData = labelOrder.map(
                (label) => apiData.find((item) => item.status === label)?.amount || 0
            );
            const seriesDataPer = labelOrder.map(
                (label) => apiData.find((item) => item.status === label)?.percentage || 0
            );

            setChargeBacksLabelsData({
                labels: labelOrder,
                series: seriesData,
                percentage: seriesDataPer,
                winRate: getChargeBacks?.win_rate
            });
        } catch (error) {


        }
    };

    const getPendingChargeBacksBarData = async () => {

        if (!headerCorporation) return;

        const payload = {
            corp_id: headerCorporation,
            pc_id: selectedProfitCenter.ID === "select" ? "" : selectedProfitCenter.ID,
            // date: DateFormater(PCdate)
            date: DateFormater(date)
        };
        const getPendingChargeBacks = await pendingBarGraph(payload);

        if (getPendingChargeBacks) {
            setPendingChargeBarData(getPendingChargeBacks);
        };

    };

    const updateTransaction = (newValue) => {
        if (!Previlage?.[0].Create) {
            enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
            return;
        }
        setTransaction(newValue);
        const match = viewTransaction.find((opt) => opt.date === newValue);
        const range = match
            ? [match.actualValue.start, match.actualValue.end]
            : [null, null];

        setDateRange(range);
        setTempDateRange(range);
        setAnchorEl(null);
    };

    const updateDateRange = (newRange) => {
        if (!newRange) {
            setDateRange([null, null]);
            setTransaction("");
            setAnchorEl(null);
            return;
        };
        setDateRange(newRange);
        const match = viewTransaction.find(
            (opt) =>
                opt.actualValue.start?.getTime() === newRange[0]?.getTime() &&
                opt.actualValue.end?.getTime() === newRange[1]?.getTime()
        );
        setTransaction(match ? match.date : "Range");
        setAnchorEl(null);
    };

    return (
        <>
            <Box component={Stack} gap={5} height={"100%"} width={"100%"} p={1} >

                <Stack gap={1.5} height={"50%"} >
                    <Stack height={"100%"} direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Typography fontSize={12} fontWeight={600}>
                            Chargebacks
                        </Typography>

                        <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={0.5}
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                        >
                            <Typography fontSize={10} color="text.secondary" fontWeight={600}>
                                {`${dateRange[0] ? dayjs(dateRange[0]).format("MM/DD/YYYY") : ""}`}
                                {" - "}
                                {`${dateRange[1] ? dayjs(dateRange[1]).format("MM/DD/YYYY") : ""}`}
                            </Typography>
                            <CalendarMonth fontSize="12px" />

                        </Stack>


                    </Stack>
                    <ChargeBackChart
                        chargeBacksLabelsData={chargeBacksLabelsData}
                        selectedProfitCenter={selectedProfitCenter}
                        selectedMerchantProvider={selectedMerchantProvider}
                        dateRange={dateRange}
                    />
                    <Typography
                        fontSize={11}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        {/* <ArrowUpward sx={{ fontWeight: 600 }} /> */}
                        <span style={{ marginLeft: 4, fontSize: "20px", fontWeight: 600 }}>{chargeBacksLabelsData?.winRate?.percentage ?? "0%"}</span>
                    </Typography>
                    <Typography fontSize={11} alignSelf={"center"} fontWeight={400}>
                        Win rate ({chargeBacksLabelsData?.winRate?.reversed_count ?? 0} / {chargeBacksLabelsData?.winRate?.total_count ?? 0})
                    </Typography>
                </Stack>


                <Stack gap={4} height={"50%"}>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                    >

                        <Typography fontSize={12} fontWeight={600}>
                            Pending Chargebacks
                        </Typography>
                        <Stack alignItems={"center"} direction={"row"}>
                            <Typography noWrap fontSize={10} fontWeight={600} color="#00000099">
                                As of:
                            </Typography>
                            <DatePicker
                                value={tempPendingChargeBackDate}
                                disabledDate={(date) => date > new Date()}

                                onChange={(value) => {
                                    if (!Previlage?.[0].Create) {
                                        enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
                                        return;
                                    }
                                    // if (!value) {
                                    //     setTempPendingChargeBackDate(tempPendingChargeBackDate);
                                    //     // setPCDate(tempPendingChargeBackDate);
                                    //     setDate(tempPendingChargeBackDate)
                                    //     return;
                                    // }

                                    if (value === null) {
                                        setTempPendingChargeBackDate((prev) => new Date(prev.getTime() + 1));
                                        setDate((prev) => new Date(prev.getTime() + 1));
                                        return;
                                    } else {

                                        setTempPendingChargeBackDate(value);

                                        const dateRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/;
                                        const formattedDate = value ? DateFormater(value) : "";

                                        if (!dateRegex.test(formattedDate)) {
                                            return
                                        };
                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);

                                        const selectedDate = new Date(value);
                                        selectedDate.setHours(0, 0, 0, 0);

                                        if (selectedDate > today) {
                                            return;
                                        }

                                        // setPCDate(value);
                                        setDate(value)
                                    }

                                }}
                                format="MM/dd/yyyy"
                                placement="auto"
                                menuStyle={{ zIndex: 1400 }}
                                cleanable={false}
                                oneTap
                                editable={true}
                                ranges={[
                                    {
                                        label: "Today",
                                        value: today,
                                    },
                                    {
                                        label: "Clear",
                                        value: null,
                                    },
                                ]}
                                size="xs"
                                appearance="subtle"
                                caretAs={() => <CalendarMonth style={{ fontSize: 15, color: "black", marginLeft: 4 }} />}
                                className="custom-dp"
                                style={{ width: 102 }}
                            />
                        </Stack>

                    </Stack>
                    <Stack>
                        <Typography fontSize={20} fontWeight={500} alignSelf={"center"} mb={2}>
                            {` $ ${formatUSAmount(pendingChargeBarData?.total_pending_amount ?? 0)}`}
                        </Typography>

                        <PercentageBar
                            left={pendingChargeBarData?.responded?.percentage ?? 0}
                            right={pendingChargeBarData?.not_responded?.percentage ?? 0}
                            // date={dayjs(PCdate).format("MM/DD/YYYY")}
                            date={dayjs(date).format("MM/DD/YYYY")}
                            selectedProfitCenter={selectedProfitCenter}


                        />
                        <Stack direction={"row"} justifyContent={"space-between"} mt={2}>
                            <Typography fontSize={11}>
                                {`Responded  $ ${formatUSAmount(pendingChargeBarData?.responded?.amount ?? 0)}`}
                            </Typography>

                            <Typography fontSize={11}>
                                {`Not Responded  $ ${formatUSAmount(pendingChargeBarData?.not_responded?.amount ?? 0)}`}
                            </Typography>
                        </Stack>
                    </Stack>

                </Stack>

            </Box>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                sx={{ p: 0 }}
            >
                <Stack spacing={2} p={2}>
                    <Autocomplete
                        options={viewTransaction.map(opt => opt.date)}
                        size="small"
                        disableClearable
                        value={transaction}
                        onChange={(e, newValue) => updateTransaction(newValue)}
                        sx={{ flexGrow: 1 }}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                {...GetReadOnlyInputProps(params)}
                                label="View Transaction"
                                variant="filled"
                            />
                        )}
                    />
                    <Stack>
                        <Typography fontSize="10px" fontWeight={400} color="#7b7b7b">
                            From & To<span style={{ color: "red", marginLeft: 2 }}>*</span>
                        </Typography>
                        <DateRangePicker

                            value={tempDateRange}
                            // onChange={(val) => setTempDateRange(val)}
                            // onOk={updateDateRange}
                            onChange={(val) => {
                                if (!Previlage?.[0].Create) {
                                    enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
                                    return;
                                }
                                setTempDateRange(val);
                            }}
                            onOk={(val) => {
                                if (!Previlage?.[0].Create) {
                                    enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
                                    return;
                                }
                                updateDateRange(val);
                            }}

                            menuStyle={{ zIndex: 1400, fontFamily: "Poppins" }}
                            format="MM/dd/yyyy"
                            size="lg"
                            ranges={[]}
                            placement="autoVerticalEnd"
                            editable
                            //  limitEndYear={0}
                            shouldDisableDate={(date) => date > new Date()}
                            showHeader={false}
                            cleanable={false}
                        />
                    </Stack>
                </Stack>
            </Popover>
        </>
    )
};
export default ChargeBacksDetails